import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import formatValue from 'scoreboard/components/format-value'
import i18n from 'scoreboard/components/i18n'
import alertMetadata from 'scoreboard/alerts/alert-metadata'
const { i18nKeys, scoreComparisons } = alertMetadata
import DomainAlertSubscriptionForm from 'scoreboard/alerts/domain-alert-subscription-form'
import permissions from 'scoreboard/components/permissions'
import template from './alert-subscription-list.hbs'
import { getCorrectSubscriptionValue } from './get-correct-subscription-value'
import config from 'scoreboard/components/config'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

/**
 * @property {Backbone.Model} model The domain object model (e.g. ScorecardNode)
 * @property {Subscription[]} model.subscriptions {id, type, comparison, threshold}
 */
const AlertSubscriptionList = Backbone.View.extend({

	tagName: 'form',

	className:  'alert-subscription-list',

	events: {
		'click .edit': 'onEdit'
	},

	initialize(options = {}) {
		this.options = options
	},

	render: function () {
		const {label, subscriptions, dataType} = this.model.attributes
		let customTextScoringType = config.customTextScoringType(this.model.attributes)
		const subscriptionList = _.map(subscriptions,
			({type, comparison, threshold: value}) => {
				value = getCorrectSubscriptionValue(value, dataType, customTextScoringType)
				const comparisonLabel = i18n.get(scoreComparisons[comparison])
				const typeLabel = i18n.get(i18nKeys[type])
				let thresholdVal = type === 'score-changed' ?
					formatValue({
						value,
						dataType: 'score'
					}) :
					formatValue({
						value,
						dataType,
						shorten: false,
						precision: 'none'
					})
				let isYesNoOrCustomText = dataType === YES_NO || customTextScoringType
				if (isYesNoOrCustomText && value === 'null') {
					// Null is displayed as "No Value" for yes/no or custom text scores
					thresholdVal = i18n.get('alerts.noValue')
				}
				return {
					// Comparison operator is required for alerts per #38187
					// so show the label if there is no value
					label: _.isNil(value) ?
						label :
						`${_.capitalize(comparisonLabel)} ${thresholdVal}`,
					typeLabel
				}
			})
		this.$el.empty().append(template({subscriptionList}))
		this.secure()
		return this
	},

	onEdit() {
		const form = new DomainAlertSubscriptionForm({model: this.model})
		form.on('done', subscriptions => this.trigger('done', subscriptions))
		appDisplay.dialog(form)
	},

	secure() {
		// #22437 hide Edit Alerts button if user does not have Modify Bookmarks and Personal Settings permissions
		if (!permissions.bookmarks()) {
			this.$('.button-container').hide()
		}
	}

})

export default AlertSubscriptionList

AlertSubscriptionList.__filename__ = 'alerts/alert-subscription-list.js'
